// extracted by mini-css-extract-plugin
export var cont = "featured-module--cont--63d7f";
export var dsk_arrowbtn = "featured-module--dsk_arrowbtn--bb679";
export var fill_space = "featured-module--fill_space--1c860";
export var forw = "featured-module--forw--cf151";
export var groups = "featured-module--groups--76679";
export var groups_wrap = "featured-module--groups_wrap--bbffb";
export var head = "featured-module--head--151a9";
export var head_btns = "featured-module--head_btns--5c2bc";
export var image = "featured-module--image--1d8a7";
export var mob_arrowbtn = "featured-module--mob_arrowbtn--5b7f7";
export var more = "featured-module--more--157d2";
export var off = "featured-module--off--db187";
export var reg_title = "featured-module--reg_title--4095b";
export var region = "featured-module--region--66b0d";
export var store = "featured-module--store--0e091";
export var title = "featured-module--title--f02f8";
export var wrap = "featured-module--wrap--d1300";